import React from "react";
import '../css/button.css';

type ButtonState = "normal" | "hover" | "focus" | "selected" | "disabled";

type ButtonProps = {
  variant?: "primary" | "danger" | "ghost";
  size?: "lg" | "md" | "sm";
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  value?: string;
  state?: ButtonState;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
};

const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  icon,
  iconPosition = "left",
  value,
  state,
  onClick,
  type = "button",
}) => {
  let classes = `scl-components-button-RoundSqureButton scl-components-button-RoundSqureButton-${variant} scl-components-button-RoundSqureButton-${size}`;

  if (state && state !== "normal") {
    classes += variant === "ghost"
        ? ` scl-components-button-RoundSqureButton-ghost-${state}`
        : ` scl-components-button-RoundSqureButton-${variant}-${state}`;
  }

  const isRealDisabled = state === "disabled";

  const iconNode = icon
    ? <span className="scl-components-button-RoundSqureButton-icon">{icon}</span>
    : null;

  return (
    <button
      type={type}
      className={classes}
      disabled={isRealDisabled}
      onClick={onClick}
    >
      {iconPosition === "left"  && iconNode}
      {value && <span>{value}</span>}
      {iconPosition === "right" && iconNode}
    </button>
  );
};

export default Button;